// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"87cf39fc","375":"654cf133","829":"92fcfe83"}[chunkId] + ".chunk.js";
};